import cn from 'classnames';

import CUSTOM_STYLES from '../../utils/modalStyle';
import GenericModal from '../GenericModal/GenericModal';

import styles from './PaymentMethodModal.module.scss';

export default function PaymentMethodModal({ isOpen, setIsOpen, paymentMethods, selectedOption, onSelect }) {
  function onElementSelected(option) {
    onSelect(option);
    setIsOpen(false);
  }

  const modal = {
    isOpen,
    closeModal: setIsOpen,
    headerClass: styles.modalHeader,
    customStyles: {
      overlay: {
        ...CUSTOM_STYLES.overlay,
      },
      content: {
        width: '41.5rem',
      },
    },
    bodyOverwrite: 'fullBody',
    isFullscreen: true,
    navigation: [<h3 key={1}>Επίλεξε τρόπο πληρωμής</h3>],
    view: 'Slots',
    body: {
      Slots: (
        <div className={styles.container}>
          {paymentMethods &&
            paymentMethods.map(option => (
              <button
                key={option.datacashReference ?? option.value}
                className={cn(styles.option, {
                  [styles.selectedOption]:
                    selectedOption?.text === option.text &&
                    selectedOption?.datacashReference === option.datacashReference,
                })}
                onClick={() => onElementSelected(option)}
              >
                {option.value === 'cash' && <img src="/assets/global/euro.svg" alt="cash" />}
                {option.value === 'card' && option.cardScheme && (
                  <img
                    src={`/assets/global/${option.cardScheme.toLowerCase().split(' ')[0]}.svg`}
                    className={styles.paymentMethodImg}
                    alt={option.cardScheme}
                  />
                )}

                {option.datacashReference === '' && <img src="/assets/global/newCard.png" alt="new card" />}
                <span>{option.text}</span>
              </button>
            ))}
        </div>
      ),
    },
  };

  return <GenericModal modal={modal} />;
}
